import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import {
    appendFollowStatus,
    followButtonClicked,
    unFollowButtonClicked,
    IsEmpty,
    redirectToUrl
} from "../../../util/commonFunctions";
import {
    hideLoader,
    showLoader
} from "../../../actions";

class RelatedTopicList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            topic: this.props.data.topic,
            secondaryTopics: this.props.data.secondaryTopics != null ? this.props.data.secondaryTopics.slice(0, 3) : []
        };
        this.appendFollowTopicStatusRespHandler = this.appendFollowTopicStatusRespHandler.bind(this);
        if (localStorage.getItem("token")) {
            appendFollowStatus(this.appendFollowTopicStatusRespHandler, localStorage.getItem("token"), this.state.topic, false, true);
            if (this.state.secondaryTopics && this.state.secondaryTopics?.length > 0) {
                appendFollowStatus(this.appendFollowSecTopicStatusRespHandler, localStorage.getItem("token"), this.state.secondaryTopics, false, true);
            }
        }
    }

    componentDidMount() {
        if (!IsEmpty(localStorage.getItem("followTopicObject"))) {
            let objectId = JSON.parse(localStorage.getItem("followTopicObject")).objectId;
            let objectType = JSON.parse(localStorage.getItem("followTopicObject")).objectType;
            if (objectType == "topic") {
                this.followObject(objectId);
                localStorage.removeItem("followTopicObject");
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != this.props) {
            if (localStorage.getItem("token")) {
                this.setState({
                    topic: nextProps.data.topic
                });
                appendFollowStatus(this.appendFollowTopicStatusRespHandler, localStorage.getItem("token"), nextProps.data.topic, false, true);
                if (nextProps.data.secondaryTopics && nextProps.data.secondaryTopics?.length > 0) {
                    appendFollowStatus(this.appendFollowSecTopicStatusRespHandler, localStorage.getItem("token"), nextProps.data.secondaryTopics.slice(0, 3), false, true);
                } else {
                    this.setState({
                        secondaryTopics: [],
                    });
                }
            } else {
                this.setState({ topic: nextProps.data.topic })
                if (nextProps.data.secondaryTopics && nextProps.data.secondaryTopics.length > 0) {
                    this.setState({
                        secondaryTopics: nextProps.data.secondaryTopics != null ? nextProps.data.secondaryTopics.slice(0, 3) : []
                    })
                } else {
                    this.setState({
                        secondaryTopics: [],
                    });
                }
            }
        }
    }

    appendFollowTopicStatusRespHandler = (response, error) => {
        this.setState({
            topic: response,
        });
    }

    appendFollowSecTopicStatusRespHandler = (response, error) => {
        this.setState({
            secondaryTopics: response,
        });
    }

    followButtonClickedRespHandler = (response, error) => {
        this.updateFollowBtnStatus(response.objectId, response.objectType);
    }

    unFollowButtonClickedRespHandler = (response, error) => {
        this.updateFollowBtnStatus(response.objectId, response.objectType);
    }

    followObject = (objectId) => {
        if (localStorage.getItem("token")) {
            followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
        } else {
            let followObject = { objectId: objectId, objectType: "topic" };
            localStorage.setItem("followTopicObject", JSON.stringify(followObject));
            this.props.openSigninModalPopup();
        }
    }

    unFollowObject = (objectId) => {
        unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
    }

    updateFollowBtnStatus = (objectId, objectType) => {
        if (objectId == this.state.topic.id) {
            this.setState(prevState => {
                let topic = Object.assign({}, prevState.topic);
                topic.isFollowed = !this.state.topic.isFollowed;
                return { topic };
            });
        } else if (this.state.secondaryTopics.length > 0) {
            let updatedSecondaryTopics = [];
            this.state.secondaryTopics.map(values => {
                if (values?.id == objectId && values.object == objectType) {
                    values.isFollowed = !values.isFollowed;
                }
                updatedSecondaryTopics.push(values);
            });
            this.setState({
                secondaryTopics: updatedSecondaryTopics
            });
        }
    }


    render = () => {
        return (
            <React.Fragment>
                <div className="video-followers-wrap">
                    {this.state.topic && (

                    <div className="video-followers">
                    <div className="video-followers-item">
                        <a
                            href={`/topic/${this.state.topic.name}/${this.state.topic.id}`}
                            onClick={event =>
                                redirectToUrl(
                                    event,
                                    this.state.topic.id,
                                    this.props,
                                    this.props.showLoader,
                                    this.props.hideLoader,
                                    this.props.currentLanguage
                                )
                            }
                        >
                            <span className={this.state.topic.isFollowed ? "color-opacity" : ""} onClick={() => this.followObject(this.state.topic.id)}>{this.state.topic.name}</span>
                        </a>
                        <div className="video-followers-btn">
                            <a href="javascript:void(null);" className={this.state.topic.isFollowed ? "topic-follow-btn hide" : "topic-follow-btn"} onClick={() => this.followObject(this.state.topic.id)} >Follow</a>
                            <a href="javascript:void(null);" className={!this.state.topic.isFollowed ? "topic-unfollow-btn hide" : "topic-unfollow-btn"} onClick={() => this.unFollowObject(this.state.topic.id)}>Following</a>
                        </div>
                    </div>
                    </div>
                    )}
                    {this.state.secondaryTopics && this.state.secondaryTopics.length > 0 && this.state.secondaryTopics.map(function (item, index) {
                        console.log("Calling secondary topics");
                        return (
                            <div key={index} className="video-followers">
                                <div className="video-followers-item">
                                    <a
                                        href={`/topic/${item.name}/${item.id}`}
                                        onClick={event =>
                                            redirectToUrl(
                                                event,
                                                item.id,
                                                this.props,
                                                this.props.showLoader,
                                                this.props.hideLoader,
                                                this.props.currentLanguage
                                            )
                                        }
                                    >
                                        <span className={item.isFollowed ? "color-opacity" : ""} onClick={() => this.followObject(this.state.topic.id)}>{item.name}</span>
                                    </a>
                                    <div className="video-followers-btn">
                                        <a href="javascript:void(null);" className={item.isFollowed ? "topic-follow-btn hide" : "topic-follow-btn"} onClick={() => this.followObject(item.id)} >Follow</a>
                                        <a href="javascript:void(null);" className={!item.isFollowed ? "topic-unfollow-btn hide" : "topic-unfollow-btn"} onClick={() => this.unFollowObject(item.id)}>Following</a>
                                    </div>
                                </div>
                            </div>
                        );
                    }, this)
                    }
                </div>
            </React.Fragment>
        );
    };
}

const mapStateToProps = state => {
    return {
      currentLanguage: state.language.currentLanguage
    };
};
  

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            showLoader,
            hideLoader
        },
        dispatch
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RelatedTopicList));
